import clicked from './clicked';

export default (win, event) => {
	let eventObject;
	/* Check for center click */
	if (event.button === 1) {
		eventObject = clicked(win, event);
		eventObject.eventData.clickType = 'center';
	}
	return eventObject;
};
